import { Markdown, Column, Container, Row } from "lcm-iot-commons";
import NavigationLegalPages from "./NavigationLegalPages";

export default function LegalMarkdownContainer({
  content,
}: {
  content: string;
}) {
  return (
    <Container>
      <Row>
        <NavigationLegalPages />
        <Column md={9}>
          <Markdown content={content} />
        </Column>
      </Row>
    </Container>
  );
}
